import * as actions from './actions'
import mutations from './mutations'
import * as getters from './getters'

const BusinessGroupStore = {
  state: {
    businessGroups: [],
    businessGroup: null
  },
  getters,
  mutations,
  actions
}

export default BusinessGroupStore